<template>
  <b-card class="mb-4">
    <h6>
      {{ v.agency }}
    </h6>
    <h4>
      <strong>{{ v.position }}</strong>
    </h4>
    <p class="address">
      {{ v.job_adress }}
    </p>
    <div class="full-info">
      <p>
        {{ v.direction_job }}
      </p>
      <p>
        {{ v.language }}
      </p>
      <p>
        {{ v.experience }}
      </p>
    </div>
    <hr />
    <div class="d-flex justify-content-between">
      <div class="meta">
        <div class="date">
          <b-icon-calendar /> {{ v.deadline.seconds | moment("DD.MM.YYYY") }}
        </div>
        <div class="salary">{{ v.salary }} грн.</div>
        <div class="category">
          Категорія: <strong> {{ v.job_category }}</strong>
        </div>
      </div>
      <div class="controls">
        <b-button
          @click="removeFromFavourites(v.id)"
          variant="link"
          class="favourites"
          size="sm"
          v-if="userData.favourites && userData.favourites.indexOf(v.id) > -1"
        >
          <b-icon-star-fill /> Збережено
        </b-button>
        <b-button
          v-else
          @click="addToFavourites(v.id)"
          variant="link"
          class="favourites"
          size="sm"
        >
          <b-icon-star /> Зберегти
        </b-button>
        <b-button target="_blank" variant="warning" size="sm" :href="v.link">
          <b-icon-link />
          Відкрити</b-button
        >
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["v"],
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      userData: "userData",
    }),
  },
  methods: {
    async fetchUser() {
      let data = await this.$db.getDocument("users", this.user.uid);
      this.$store.commit("setUserData", data);
    },
    async removeFromFavourites(id) {
      let favourites = this.userData.favourites;
      let index = favourites.indexOf(id);
      favourites.splice(index, 1);
      await this.$db.update("users", this.user.uid, { favourites: favourites });
      this.$emit("removed", id);
      this.fetchUser();
    },
    async addToFavourites(id) {
      let favourites = [];
      if (this.userData.favourites) {
        favourites = this.userData.favourites;
      }
      favourites.push(id);
      await this.$db.update("users", this.user.uid, { favourites: favourites });
      this.fetchUser();
    },
  },
};
</script>

<style lang="scss" scoped>
.date {
  font-size: 14px;
  font-weight: bold;
  color: #666;
  svg {
    margin-right: 4px;
  }
}
.full-info {
  max-height: 0px;
  height: auto;
  overflow: hidden;
}
.meta {
  display: flex;
  align-items: center;
  & > div {
    margin-right: 32px;
    font-size: 13px !important;
  }
}
h6 {
  font-size: 14px;
}
h4 {
  font-size: 18px;
  margin-bottom: 20px;
}
hr {
  margin-top: 5px;
  margin-bottom: 12px;
}
.address {
  color: var(--primary-color);
  font-weight: 600;
  font-size: 14px;
}
.salary {
  margin-right: auto;
  font-weight: bold;
  font-size: 14px;
}
.controls {
  .favourites {
    text-decoration: none;
    font-size: 12px;
    margin-right: 18px;
  }
}
</style>
